"use strict";

exports.__esModule = true;
exports.ActivitiesChartDataFormatter = void 0;
var _react = _interopRequireDefault(require("react"));
var _BarChart = require("../../common/AggregateMetricCharts/BarChart");
var _Metrics = require("../../../../Catalogs/Metrics");
var _TimeContext = require("../../../Time/TimeContext");
var _sortEventsByWorkdayStart = require("../../common/utils/sortEventsByWorkdayStart");
var _formatToPlantTime = require("../../common/utils/formatToPlantTime");
var _timeAggregationBinMapping = require("../../../VIMANAMetrics/timeAggregationBinMapping");
var _SelectedDevicesController = require("../../../Device/SelectedDevicesController");
var _getUniqueTimestamps = require("../../common/utils/getUniqueTimestamps");
var _getTooltip = require("./getTooltip");
var _KeyColorWrapper = require("../../common/styles/KeyColorWrapper");
var _utils = require("./utils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function createTimeAggregatedSeries(_ref) {
  var timeAggregationName = _ref.timeAggregationName,
    data = _ref.data,
    timezone = _ref.timezone,
    selectedStates = _ref.selectedStates,
    selectedActivities = _ref.selectedActivities,
    currentWorkday = _ref.currentWorkday,
    _ref$activityDetails = _ref.activityDetails,
    activityDetails = _ref$activityDetails === void 0 ? [] : _ref$activityDetails,
    tooltipSort = _ref.tooltipSort;
  if (!timezone || !currentWorkday) return [];
  var timeBinName = (0, _timeAggregationBinMapping.getTimeGroupingBinName)(timeAggregationName || "").replace("by_", "");
  if (timeAggregationName === _timeAggregationBinMapping.HOUR_PER_DAY) {
    data = (0, _formatToPlantTime.formatToPlantTime)({
      data: data,
      timezone: timezone,
      binName: timeBinName
    });
  }
  var timestamps = (0, _getUniqueTimestamps.getUniqueTimestamps)({
    data: data,
    binName: timeBinName
  });
  var seriesData = timestamps.map(function (timestamp) {
    var by_activity = data.reduce(function (activities, doc) {
      var key = (0, _utils.getActivityKey)(doc);
      if (timestamp === doc[timeBinName] && selectedStates.find(function (state) {
        return state.key === doc["state"];
      }) && selectedActivities.find(function (activity) {
        return activity.key === key;
      })) {
        if (!activities[key]) {
          var _Object$assign;
          return Object.assign({}, activities, (_Object$assign = {}, _Object$assign[key] = {
            key: key,
            duration: doc.duration_sum || 0,
            value: 1,
            devices: [doc.device]
          }, _Object$assign));
        }
        activities[key].duration += doc.duration_sum || 0;
        activities[key].devices.push(doc.device);
      }
      return activities;
    }, {});
    by_activity = Object.values(by_activity);
    return (0, _utils.formatActivities)({
      timestamp: timestamp,
      activities: by_activity,
      activityDetails: activityDetails,
      tooltipSort: tooltipSort
    });
  });
  if (timeAggregationName === _timeAggregationBinMapping.HOUR_OF_DAY) {
    seriesData = (0, _sortEventsByWorkdayStart.sortEventsByWorkdayStart)(seriesData, timezone.name, currentWorkday.interval.startMillis);
  } else {
    seriesData.sort(function (a, b) {
      return new Date(a.key).getTime() > new Date(b.key).getTime() ? 1 : -1;
    });
  }
  return seriesData;
}
function createSummarySeries(_ref2) {
  var data = _ref2.data,
    selectedStates = _ref2.selectedStates,
    selectedActivities = _ref2.selectedActivities,
    _ref2$activityDetails = _ref2.activityDetails,
    activityDetails = _ref2$activityDetails === void 0 ? [] : _ref2$activityDetails,
    tooltipSort = _ref2.tooltipSort;
  var activitiesByKey = data.filter(function (doc) {
    return selectedStates.findIndex(function (v) {
      return v.key === doc["state"];
    }) >= 0 && selectedActivities.find(function (activity) {
      return activity.key === (0, _utils.getActivityKey)(doc);
    });
  }).reduce(function (acc, doc) {
    var _Object$assign2;
    var key = (0, _utils.getActivityKey)(doc);
    if (!acc[key]) return Object.assign({}, acc, (_Object$assign2 = {}, _Object$assign2[key] = {
      key: key,
      duration: doc.duration_sum || 0,
      devices: [doc.device],
      value: 1
    }, _Object$assign2));
    acc[key].duration += doc.duration_sum || 0;
    acc[key].devices.push(doc.device);
    return acc;
  }, {});
  var activities = Object.values(activitiesByKey);
  var seriesData = [(0, _utils.formatActivities)({
    activities: activities,
    timestamp: " ",
    activityDetails: activityDetails,
    tooltipSort: tooltipSort
  })];
  return seriesData;
}
var createSeries = function createSeries(_ref3) {
  var data = _ref3.data,
    timeAggregationName = _ref3.timeAggregationName,
    showTooltip = _ref3.showTooltip,
    activityDetails = _ref3.activityDetails,
    currentWorkday = _ref3.currentWorkday,
    timezone = _ref3.timezone,
    _ref3$selectedStates = _ref3.selectedStates,
    selectedStates = _ref3$selectedStates === void 0 ? [] : _ref3$selectedStates,
    _ref3$selectedActivit = _ref3.selectedActivities,
    selectedActivities = _ref3$selectedActivit === void 0 ? [] : _ref3$selectedActivit,
    _ref3$devices = _ref3.devices,
    devices = _ref3$devices === void 0 ? [] : _ref3$devices,
    tooltipSort = _ref3.tooltipSort;
  if (data.length === 0) {
    return {
      series: [],
      totalMinorBar: 0
    };
  }
  var seriesData = [];
  if (timeAggregationName) {
    seriesData = createTimeAggregatedSeries({
      timeAggregationName: timeAggregationName,
      data: data,
      timezone: timezone,
      selectedStates: selectedStates,
      selectedActivities: selectedActivities,
      currentWorkday: currentWorkday,
      activityDetails: activityDetails,
      tooltipSort: tooltipSort
    });
  } else {
    seriesData = createSummarySeries({
      data: data,
      selectedStates: selectedStates,
      selectedActivities: selectedActivities,
      activityDetails: activityDetails,
      tooltipSort: tooltipSort
    });
  }
  var metric = (0, _Metrics.getMetricDefinition)("activities");
  var series = [{
    metricName: metric.name,
    unit: metric.units,
    color: "#AAAAAA",
    data: seriesData,
    getXValue: function getXValue(item) {
      return item.key;
    },
    getYValue: function getYValue(item) {
      return item.value;
    },
    getTooltip: showTooltip ? (0, _getTooltip.getTooltip)(activityDetails || [], devices, tooltipSort) : undefined,
    render: function render(props) {
      return /*#__PURE__*/_react["default"].createElement(_BarChart.BarChart, props);
    },
    toolTipPosition: timeAggregationName ? "right" : "auto"
  }];
  return {
    series: series,
    totalMinorBar: 1
  };
};
var ActivitiesChartDataFormatter = exports.ActivitiesChartDataFormatter = function ActivitiesChartDataFormatter(props) {
  var devices = (0, _SelectedDevicesController.useSelectedDevices)();
  var timeProps = _react["default"].useContext(_TimeContext.TimeContext);
  var _createSeries = createSeries(Object.assign({}, timeProps, props, {
      devices: devices
    })),
    series = _createSeries.series,
    totalMinorBar = _createSeries.totalMinorBar;
  return /*#__PURE__*/_react["default"].createElement(_KeyColorWrapper.KeyColorWrapper, {
    keyColorArray: props.activityDetails
  }, props.children({
    series: series,
    totalMinorBar: totalMinorBar
  }));
};